export enum AcquaintanceLackTypeCodesEnum {
  ACQ_TYPE_I = 'ACQL_TYPE_I',
  ACQ_TYPE_II = 'ACQL_TYPE_II',
}
